import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/app/(charts)/calculators/annual-income-calculator/page.client.jsx");
